const MIN_SCROLL_TOP = 200;
const MAX_SCROLL_TOP = 500;

export const SCROLL_TOP_RANGE: [number, number] = [
  MIN_SCROLL_TOP,
  MAX_SCROLL_TOP,
];
